
import { IContractTemplateForm, IDistributionMutation } from 'services/templates/types';
import { separateTemplateTreeItems } from '../templateFormItemsSeparator';

export const merchDistributionTemplateFormToQuery = (
  contract: IContractTemplateForm
): IDistributionMutation | null => {
  const { merchDistribution } = separateTemplateTreeItems(
    contract.items[0].children
  );

  return merchDistribution ?? null;
};
